<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001936')"
							paramKey="pmcNo"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.pmcNo"
							:readonly="true"
							:placeholder="getMessage_('QWCC001656')"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="pmcPopupOpen"></i></template>
						</search-input>
					</el-col>
					<el-col :span="2">
						<search-input :label="getMessage_('QWCC001379')" paramKey="ipnNos" :propData="searchParams.ipnNos" :readonly="true">
						</search-input>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		<pmc-popup ref="pmcPopup" @Refresh="refresh" :scrId="scrId" @sendPmc="getPmc"></pmc-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import PmcPopup from './Popup/PmcPopup.vue';

export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			radio: '',
			custList: []
		};
	},
	created() {
		this.custList = [
			{ label: this.getMessage_('QWCC001476'), value: 'Y' },
			{ label: this.getMessage_('QWCC001763'), value: 'N' }
		];
	},
	components: { SearchInput, PmcPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			if (param.key === 'pmcNo') {
				this.setSearchParam_({ key: 'ipnNos', value: '' });
			}
			this.setSearchParam_(param);
		},
		pmcPopupOpen() {
			this.$refs.pmcPopup.open();
		},
		async getPmc({ pmcNo, ipnNos, custCd, custNm }) {
			this.$sf_toggleLoading(true);
			this.setSearchParam_({ key: 'pmcNo', value: pmcNo });
			this.setSearchParam_({ key: 'ipnNos', value: ipnNos });
			this.setSearchParam_({ key: 'custCd', value: custCd });
			this.setSelectedRow_({ key: 'pmcNo', value: pmcNo });
			this.setSelectedRow_({ key: 'ipnNos', value: ipnNos });
			this.setSelectedRow_({ key: 'custCd', value: custCd });
			this.setSelectedRow_({ key: 'custNm', value: custNm });
			await this.getList_();
			this.$sf_toggleLoading(false);
		},
		refresh() {},
		async searchList() {
			try {
				if (!this.isPqyUser) throw new Error(this.getMessage_('QWCC001923')); //해당메뉴에 접근 권한이 없습니다. 관리자에게 권한을 요청하세요.
				if (!this.searchParams.pmcNo)
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000974')]));
				this.$sf_toggleLoading(true);
				this.setSearchParam_({ key: 'custCd', value: '' });
				this.setSearchParam_({ key: 'custNm', value: '' });
				await this.getList_();
				this.setState_({ key: 'attentionList', value: [] });
				this.setState_({ key: 'okList', value: [] });
				this.setState_({ key: 'ngList', value: [] });
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
